import { gsap, ScrollTrigger, SplitText } from 'gsap/all'
import { splitTitle } from './split-title'
import { splitText } from './split-text'

gsap.registerPlugin(SplitText, ScrollTrigger)

export function hero(element: Element): void {
  const image = element.querySelector('.js-image') as HTMLImageElement
  element.classList.remove('js-hidden')

  // js title
  const title = [...Array.from(element.querySelectorAll('.js-title'))] as HTMLElement[]
  const features = [...Array.from(element.querySelectorAll('.js-feature'))] as HTMLElement[]
  const subtitle = element.querySelector('.js-subtitle') as HTMLElement
  const desc = element.querySelector('.js-desc') as HTMLElement
  const button = element.querySelector('.js-button') as HTMLElement

  if (button) gsap.set(button, { autoAlpha: 0, yPercent: 25 })
  if (features) gsap.set(features, { autoAlpha: 0, yPercent: 50 })

  if (title.length) {
    title.forEach(title => {
      splitTitle(title, {
        playImmediately: true
      })
    })
  }
  if (subtitle)
    splitText(subtitle, {
      trigger: element,
      start: 'top+=25% bottom',
      end: 'center bottom',
      markers: false,
      delay: 1
    })

  if (features) gsap.to(features, { duration: 1, autoAlpha: 1, stagger: 0.1, yPercent: 0, ease: 'expo.out', delay: 1 })

  if (desc)
    splitText(desc, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false, delay: 1 })
  if (button) gsap.to(button, { duration: 1, autoAlpha: 1, yPercent: 0, ease: 'expo.0ut', delay: 1 })

  if (image) {
    gsap.set(image, { autoAlpha: 0 })

    gsap.to(image, {
      duration: 1,
      autoAlpha: 1,
      ease: 'expo.inOut',
      delay: 0.25
    })
  }
}
